// Reviewed photos for the northern Morocco hub. CMS slots remain editable.
// Keep each placement distinct, including overview cards and video posters.
export const NORTH_HUB_IMAGES = {
  hero: "https://xalucatours-media.b-cdn.net/xaluca/library/pexels_30398389_e00a5d06.webp",
  overviewImperial: "https://xalucatours-media.b-cdn.net/xaluca/library/unsplash_GE9HkJwwQNY_bb49ec68.jpg",
  overviewRif: "https://xalucatours-media.b-cdn.net/xaluca/library/4d1d52470e6f41e68cc0dc847c8563ec.webp",
  itineraryImperial: "https://xalucatours-media.b-cdn.net/xaluca/library/pexels_38112083_c2dc08b2.webp",
  editorialImperial: "https://xalucatours-media.b-cdn.net/xaluca/library/migrated_db8f89f811c0479ca58da8bce8d3ebd2.webp",
  videoImperial: "https://xalucatours-media.b-cdn.net/xaluca/library/4e36e2af7adc44a38e34187e6227d6b9.webp",
  itineraryRif: "https://xalucatours-media.b-cdn.net/xaluca/library/pexels_28582577_dd6fc9fa.webp",
  editorialRif: "https://xalucatours-media.b-cdn.net/xaluca/library/pexels_33912197_4669ade8.jpg",
  videoRif: "https://xalucatours-media.b-cdn.net/xaluca/library/pexels_27465667_33864084.webp",
  galleryImperial: [
    "https://xalucatours-media.b-cdn.net/xaluca/library/pexels_38112371_43d5138b.webp",
    "https://xalucatours-media.b-cdn.net/xaluca/library/unsplash_n6lzuAV-u1U_bd1ef845.jpg",
    "https://xalucatours-media.b-cdn.net/xaluca/library/pexels_29595720_e18f07c2.jpg",
    "https://xalucatours-media.b-cdn.net/xaluca/library/4ff33d07ff2146a2ad64d2b4c7b80652.webp",
    "https://xalucatours-media.b-cdn.net/xaluca/library/pexels_13794310_59a43485.jpg",
    "https://xalucatours-media.b-cdn.net/xaluca/library/963f6bf3b353499c88e3ee87ffc55719.webp",
  ],
  galleryRif: [
    "https://xalucatours-media.b-cdn.net/xaluca/library/pexels_37926823_229f2a63.webp",
    "https://xalucatours-media.b-cdn.net/xaluca/library/pexels_9433813_d9a6ad9a.webp",
    "https://xalucatours-media.b-cdn.net/xaluca/library/bee86b36199549fbbaff5b80ac8fdba4.webp",
    "https://xalucatours-media.b-cdn.net/xaluca/library/pexels_36244505_fb5f574a.jpg",
    "https://xalucatours-media.b-cdn.net/xaluca/library/pexels_25254927_a505c070.webp",
    "https://xalucatours-media.b-cdn.net/xaluca/library/e44fe101dd904ac0ae9b03cdc0d0fe72.webp",
  ],
};
